import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useController, useFormContext } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  BUTTON_ADD_RE_TARGETING,
  MODAL_CUSTOM_AUDIENCES_TITLE,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE,
  SIZE_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import Button from "../../../Buttons/Button";
import ModalCustomAudiencesListTikTok from "./ModalCustomAudiencesListTikTok";
import AudienceCard from "../../../Form/AudienceCard";
import { numberCompactFormat } from "../../../../utils/numbers";
import { getReactHookFormNestedError } from "../../../../utils/errors";

const AdGroupCustomAudiencesContainerTikTok = ({
  BASIC_PATH,
  control,
  name,
  errors = {},
  disabled = false,
  isExcludedAudiences = false,
}) => {
  const [modalOpenCustomAudiences, setModalOpenCustomAudiences] =
    useState(false);
  const { t } = useTranslationApp();
  const { getValues } = useFormContext();

  const error = getReactHookFormNestedError(errors, name);

  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });

  const customAudiences = value || [];
  const platform = getValues(`${BASIC_PATH}.platform`);
  const platformData = getValues(`platformsData.${platform}`) || {};

  return (
    <Box
      id={name}
      sx={{
        mb: 1,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          mb: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "#000",
          "& .MuiSvgIcon-root": {
            fontSize: "1.25rem",
            display: "flex",
            alignItems: "center",
            color: isExcludedAudiences
              ? "#FF4D4D !important"
              : "#4CAF50 !important",
          },
        }}
      >
        <PersonOutlineIcon />
        {t(
          isExcludedAudiences
            ? MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE
            : MODAL_CUSTOM_AUDIENCES_TITLE
        )}
      </Typography>
      {error && (
        <Typography variant="body2" color="error" id={name} sx={{ mb: 2 }}>
          {error.message}
        </Typography>
      )}
      <Grid container spacing={2}>
        {customAudiences.map((customAudience) => (
          <AudienceCard
            key={customAudience.id}
            title={customAudience.name || customAudience.id}
            isValid={customAudience.isValid}
            disabled={disabled}
            onDelete={() =>
              onChange(value.filter((c) => c.id !== customAudience.id))
            }
            sx={{ color: "white" }}
          >
            {customAudience.type && (
              <Typography variant="body2">{customAudience.type}</Typography>
            )}
            {customAudience?.size && (
              <Typography variant="body2">
                {`${t(SIZE_PLACEHOLDER)}: ${numberCompactFormat(customAudience?.size || 0)}`}
              </Typography>
            )}
          </AudienceCard>
        ))}
      </Grid>
      {!disabled && (
        <Box sx={{ mt: 2, width: "100%" }}>
          <Button
            type="button"
            color="secondary"
            startIcon={<AddIcon />}
            onClick={() => setModalOpenCustomAudiences(true)}
            sx={{
              width: "100%",
            }}
          >
            {t(BUTTON_ADD_RE_TARGETING)}
          </Button>
        </Box>
      )}
      {modalOpenCustomAudiences && (
        <ModalCustomAudiencesListTikTok
          modalOpen={modalOpenCustomAudiences}
          onCloseModal={() => setModalOpenCustomAudiences(false)}
          platform={platform}
          isExcludedAudiences={isExcludedAudiences}
          adAccountID={platformData.adAccountID}
          integrationID={platformData.integrationID}
          filteredCustomAudiences={customAudiences.map((c) => c.id)}
          onCallbackSave={(customAudiences) => {
            onChange(value ? [...value, ...customAudiences] : customAudiences);
            setModalOpenCustomAudiences(false);
          }}
        />
      )}
    </Box>
  );
};

export default AdGroupCustomAudiencesContainerTikTok;
